export default {
    BCG: 15,
    FLU3V: 33,
}